
import React from 'react'
import Button from '@material-ui/core/Button';
import DataProvider from '../DataProvider';

const RemoveButton = props => {

    const data = props.orgrecord
    const isZone = props.iszone

    const warningMessage = isZone ? `Warning, this cannot be undone. The zone ${props.name} will be PERMANENTLY DELETED.` : `Warning, this cannot be undone. The record ${props.name} will be removed from this organization.`
    async function handleClick() {
        try {
            if (window.confirm(warningMessage)) {
                data[props.targetresource + "_to_remove"] = [props.id]
                data[props.targetresource + "_to_add"] = []
                await DataProvider.update('organizations', { id: data.id, data, })
                props.handleupdate()
            }
        } catch (e) {
            console.warn(e)
        }
    }

    return (
        <Button
            style={{
                fontSize: '10',
                color: "red",
                borderRadius: '10px',
                textAlign: 'center',
            }}
            onClick={handleClick}>
            <div>
                Remove
            </div>
        </Button>
    );
}

export default RemoveButton